import { ODataHelper } from "@js/helpers/ODataHelper";
import { AuthService } from "@js/services/AuthService";
import { SharedCriteriaService } from "@js/services/Deal/SharedCriteriaService";
import { OrganisationService } from "@js/services/OrganisationService";
import { RoleService } from "@js/services/RoleService";
import { UserService } from "@js/services/UserService";
import {
  BrickflowEventLogClient,
  LenderClient,
  LinkTypeEnum,
  Organisation,
  OrganisationClient,
  OrganisationLink,
  OrganisationLinkClient,
  OrganisationLinkCrudClient,
  ProductFamilyEnum,
  ProductTypeEnum,
  StaticDataClient,
  UserClient,
} from "@src/apis/ModularClient";

export class AllLoansLandingController {
  isLoggedInUser: boolean = false;
  totalLenders: number = 0;
  isBorrower: boolean = false;
  orgCode: string | null;
  organisationLink: OrganisationLink;
  previewContent: boolean = false;
  organisation: Organisation;

  //error message to enterprise client when organisation does not have a valid permission
  noPermissionErrorMsg: string = "";
  dataLoading: boolean = false;

  isCommercialOwnerOccupiedActive: boolean = false;

  showHelpModal: boolean = false;
  headerProductFamily: ProductFamilyEnum = ProductFamilyEnum.None;
  enterpriseLinkLogo: string;
  showBridgingOption: boolean = false;
  showCommercialOption: boolean = false;
  showDevFinanceOption: boolean = true;
  isBridgingDisabled: boolean = false;
  isCommercialDisabled: boolean = false;

  isWidget: boolean = false;
  showCriteriaSection: boolean = false;
  isMobileView: boolean = false;
  isWidgetMinimised: boolean = false;

  productFamilyType: ProductFamilyEnum[] = [ProductFamilyEnum.None];

  linkIdRouteParam: string = null;

  static $inject = [
    "$scope",
    "$routeParams",
    "$cookies",
    "$location",
    "$q",
    "AuthService",
    "OrganisationClient",
    "LenderClient",
    "BrickflowEventLogClient",
    "OrganisationLinkClient",
    "SharedCriteriaService",
    "UserClient",
    "$rootScope",
    "OrganisationService",
    "StaticDataClient",
    "RoleService",
    "UserService",
    "OrganisationLinkCrudClient",
    "ODataHelper",
  ];

  constructor(
    private $scope: ng.IScope,
    private $routeParams: ng.route.IRouteParamsService,
    private $cookies: ng.cookies.ICookiesService,
    private $location: ng.ILocationService,
    protected $q: ng.IQService,
    private $auth: AuthService,
    private organisationClient: OrganisationClient,
    private lenderClient: LenderClient,
    private eventLogClient: BrickflowEventLogClient,
    private organisationLinkClient: OrganisationLinkClient,
    private sharedCriteriaService: SharedCriteriaService,
    private userClient: UserClient,
    public $rootScope: ng.IRootScopeService,
    private organisationService: OrganisationService,
    private staticDataClient: StaticDataClient,
    public roleService: RoleService,
    public userService: UserService,
    public organisationLinkCrudClient: OrganisationLinkCrudClient,
    private odataHelper: ODataHelper,
  ) {
    if ($cookies.get("access_token")) {
      this.isLoggedInUser = true;
    }

    if (window.self == window.top) {
      this.orgCode = this.$cookies.get("org_code");
    } else {
      this.orgCode = location.pathname.replace("/", "");
    }

    if (this.$routeParams.linkId) {
      this.linkIdRouteParam = this.$routeParams.linkId;
    }

    if (this.isLoggedInUser) {
      this.roleService.isClientUser().then((isClient: boolean) => {
        if (this.orgCode && this.orgCode != "undefined" && this.orgCode != "") {
          this.userService.GetDefaultBrokerOrganisation().then((userDefaultBrokerOrg: Organisation) => {
            if (userDefaultBrokerOrg && userDefaultBrokerOrg.organisationCode != this.orgCode) {
              const broadcastResult = this.$rootScope.$broadcast("logout");

              if (broadcastResult.defaultPrevented) return;

              this.$auth.logout(false);
              window.location.reload();
            }
          });
        }
      });

      if (
        this.productFamilyType.includes(ProductFamilyEnum.None) ||
        this.productFamilyType.includes(ProductFamilyEnum.Commercial)
      ) {
        this.staticDataClient.isCommercialOwnerOccupiedActive().then((response) => {
          this.isCommercialOwnerOccupiedActive = response;
        });
      }

      this.setProductButtonStateAndVisibility();
    } else {
      this.init();
    }

    if (this.$routeParams.context == "widget") {
      if (window.self != window.top) {
        if (!(this.$rootScope as any).previousRoute.startsWith("/e/enterpriseleadcapture")) {
          this.organisationService.sendDataToParent("height", "170px");
        }
        this.isWidget = true;
      } else {
        this.noPermissionErrorMsg =
          "This URL is designed to be embedded into a site, as a widget. If you would like the user to access this search directly, please use an Enterpise link.";
      }
    } else if (window.innerWidth <= 480 && window.self == window.top) {
      this.isMobileView = true;
    }

    //This event is added to navigate user to devfinance critera on click of devfinance link from helper text, when user is on Bare Land path for purchase/refinance search.
    const productFamilySelectionUnregister = $scope.$on(
      "productFamilySelection",
      (event: ng.IAngularEvent, newValue) => {
        this.updateProdcutFamilyOption(newValue);
      },
    );

    $scope.$on("$destroy", productFamilySelectionUnregister);
  }

  getNumberOfLenders(orgId) {
    this.lenderClient.getTotalLenders(ProductFamilyEnum.None, orgId).then((totalLenders: number) => {
      this.totalLenders = Math.floor(totalLenders / 5) * 5;
    });
  }

  updateProdcutFamilyOption(val) {
    this.headerProductFamily = val;
  }

  async initialRegisterEventLog(orgCode, organisationLinkId = null) {
    if (window.self == window.top) {
      if (sessionStorage.getItem("clientId")) {
        this.eventLogClient.logPageLoad(
          this.productFamilyType.length > 0 || this.productFamilyType[0] == ProductFamilyEnum.None
            ? "ALLLOANS"
            : `${this.getProductFamilyText().toUpperCase()}`,
          orgCode,
          "",
          "Client",
          organisationLinkId,
          ProductTypeEnum.None,
          undefined,
          undefined,
          parseInt(sessionStorage.getItem("clientId")),
        );
      } else {
        this.eventLogClient.logPageLoad("ALLLOANS", orgCode, "", "Client", organisationLinkId, ProductTypeEnum.None);
      }
    } else {
      let clientId: number = null;
      clientId = Number(this.organisationService.getData("clientId"));
      if (clientId) {
        this.eventLogClient.logPageLoad(
          this.productFamilyType.length > 0 || this.productFamilyType[0] == ProductFamilyEnum.None
            ? "ALLLOANS"
            : `${this.getProductFamilyText().toUpperCase()}`,
          orgCode,
          "",
          "Client",
          organisationLinkId,
          ProductTypeEnum.None,
          undefined,
          undefined,
          clientId,
        );
      } else {
        this.eventLogClient.logPageLoad(
          this.productFamilyType.length > 0 || this.productFamilyType[0] == ProductFamilyEnum.None
            ? "ALLLOANS"
            : `${this.getProductFamilyText().toUpperCase()}`,
          orgCode,
          "",
          "Client",
          organisationLinkId,
          ProductTypeEnum.None,
        );
      }
    }
  }

  logEvent() {
    if (this.linkIdRouteParam) {
      if (this.orgCode) {
        this.initialRegisterEventLog(this.orgCode, Number(this.linkIdRouteParam));
      } else {
        this.initialRegisterEventLog("", Number(this.linkIdRouteParam));
      }
    } else {
      if (this.orgCode) {
        this.initialRegisterEventLog(this.orgCode);
      } else {
        this.initialRegisterEventLog("");
      }
    }
  }

  onClickShowHelpModal() {
    this.showHelpModal = true;
    if (this.isWidget && !this.showCriteriaSection) this.organisationService.sendDataToParent("height", "745px");
  }

  closeHelpModal() {
    if (this.isWidget && !this.showCriteriaSection) this.organisationService.sendDataToParent("height", "170px");
    this.showHelpModal = false;
  }

  selectDefaultProductFamily() {
    if (
      this.showBridgingOption &&
      !this.isBridgingDisabled &&
      (this.productFamilyType.includes(ProductFamilyEnum.None) ||
        this.productFamilyType.includes(ProductFamilyEnum.Bridging))
    ) {
      this.headerProductFamily = ProductFamilyEnum.Bridging;
    } else if (
      this.showCommercialOption &&
      !this.isCommercialDisabled &&
      (this.productFamilyType.includes(ProductFamilyEnum.None) ||
        this.productFamilyType.includes(ProductFamilyEnum.Commercial))
    ) {
      this.headerProductFamily = ProductFamilyEnum.Commercial;
    } else if (
      this.productFamilyType.includes(ProductFamilyEnum.None) ||
      this.productFamilyType.includes(ProductFamilyEnum.Development)
    ) {
      this.headerProductFamily = ProductFamilyEnum.Development;
    }
    this.showCriteriaSection = true;
  }

  setProductButtonStateAndVisibility() {
    this.userClient.getCurrentUserPermissionForProductSearch().then((response) => {
      if (response) {
        if (response.isLender) {
          this.showBridgingOption = response.hasBridgingSearchPermission;
          this.showDevFinanceOption = response.hasDevFinanceSearchPermission;
          this.showCommercialOption = response.hasCommercialSearchPermission;
        } else {
          this.isBridgingDisabled = !response.hasBridgingSearchPermission;
          this.isCommercialDisabled = !response.hasCommercialSearchPermission;
          this.showBridgingOption = true;
          this.showDevFinanceOption = true;
          this.showCommercialOption = true;
        }
        this.getNumberOfLenders(response.orgId);
        this.selectDefaultProductFamily();
      } else {
        //This is to navigate a user to userdashboard when they try to access path directly
        this.$location.path("/userdashboard");
      }
    });
  }

  showorHideCriteriaSection() {
    if (this.showCriteriaSection) {
      this.organisationService.sendDataToParent("height", "170px");
    }
    this.showCriteriaSection = !this.showCriteriaSection;
  }

  toggleMinimiseWidget() {
    this.isWidgetMinimised = !this.isWidgetMinimised;
    const newHeight = this.isWidgetMinimised ? "195px" : this.showCriteriaSection ? "745px" : "170px";

    this.organisationService.sendDataToParent("height", newHeight);
  }

  footerSignInClicked() {
    const baseUrl = window.location.href.split("#!")[0] + "#!";
    const newUrl = `${baseUrl}/login`;
    window.open(newUrl, "_blank");
  }

  getProductFamiliesByLinkType(linkType) {
    const families: ProductFamilyEnum[] = [];

    if ((linkType & LinkTypeEnum.Development) === LinkTypeEnum.Development) {
      families.push(ProductFamilyEnum.Development);
    }
    if ((linkType & LinkTypeEnum.Bridging) === LinkTypeEnum.Bridging) {
      families.push(ProductFamilyEnum.Bridging);
    }
    if ((linkType & LinkTypeEnum.Commercial) === LinkTypeEnum.Commercial) {
      families.push(ProductFamilyEnum.Commercial);
    }

    return families;
  }

  async getProductFamiliesByUniqueId(): Promise<ProductFamilyEnum[]> {
    let families: ProductFamilyEnum[] = [];
    const response = await this.organisationLinkClient.getOrganisarionlinkUniqueId(this.$routeParams.uniqueId);
    this.linkIdRouteParam = response.id.toString();
    families = this.getProductFamiliesByLinkType(response.linkType);
    return families;
  }

  onStartSearchButtonClick() {
    switch (this.productFamilyType[0]) {
      case ProductFamilyEnum.Development:
        this.headerProductFamily = ProductFamilyEnum.Development;
        break;
      case ProductFamilyEnum.Bridging:
        this.headerProductFamily = ProductFamilyEnum.Bridging;
        break;
      case ProductFamilyEnum.Commercial:
        this.headerProductFamily = ProductFamilyEnum.Commercial;
        break;
      default:
        break;
    }
    this.showCriteriaSection = true;
  }

  getProductFamilyText(): string {
    const texts = this.productFamilyType.map((type) => {
      switch (type) {
        case ProductFamilyEnum.Development:
          return "Development";
        case ProductFamilyEnum.Bridging:
          return "Bridging";
        case ProductFamilyEnum.Commercial:
          return "Commercial";
        case ProductFamilyEnum.None:
          return "None";
        default:
          return "";
      }
    });

    // Filter out any empty strings and join with comma
    return texts.filter((text) => text !== "").join(", ");
  }

  async init(): Promise<void> {
    if (this.$routeParams.linkType) {
      this.productFamilyType = this.getProductFamiliesByLinkType(Number(this.$routeParams.linkType));
    } else if (this.$routeParams.uniqueId) {
      this.productFamilyType = await this.getProductFamiliesByUniqueId();
    }

    if (
      this.productFamilyType.includes(ProductFamilyEnum.None) ||
      this.productFamilyType.includes(ProductFamilyEnum.Commercial)
    ) {
      this.staticDataClient.isCommercialOwnerOccupiedActive().then((response) => {
        this.isCommercialOwnerOccupiedActive = response;
      });
    }

    this.sharedCriteriaService.setPreviousUrl(this.$location.absUrl());

    /* if (this.$location.path().startsWith("/allloans")) {
        this.sharedCriteriaService.storeEnterpriseLinkType(
          this.$routeParams.linkType ? this.$routeParams.linkType.toString() : LinkTypeEnum.AllLoans.toString(),
        );
      }*/

    this.organisationClient
      .getOrgByUrlIfOrgHasEnterpriseSearchPermission(
        this.orgCode ?? null,
        this.productFamilyType.length === 1 && this.isWidget ? this.productFamilyType[0] : ProductFamilyEnum.None,
        this.linkIdRouteParam ?? null,
      )
      .then((response) => {
        if (!response) {
          this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
          return;
        }

        this.organisation = response;
        this.getNumberOfLenders(this.organisation.id);
        this.orgCode = response.organisationCode;

        this.showBridgingOption =
          response.hasBridging &&
          (this.productFamilyType.includes(ProductFamilyEnum.None) ||
            this.productFamilyType.includes(ProductFamilyEnum.Bridging));

        this.showCommercialOption =
          response.hasCommercialMortgage &&
          (this.productFamilyType.includes(ProductFamilyEnum.None) ||
            this.productFamilyType.includes(ProductFamilyEnum.Commercial));

        this.showDevFinanceOption =
          this.productFamilyType.includes(ProductFamilyEnum.None) ||
          this.productFamilyType.includes(ProductFamilyEnum.Development);

        if ((this.isWidget && this.organisation.hasWidget) || !this.isWidget) {
          if (
            !this.isWidget ||
            ((this.$rootScope as any).previousRoute.startsWith("/e/enterpriseleadcapture") && this.isWidget)
          ) {
            this.selectDefaultProductFamily();
          }

          const imgs = document.getElementsByTagName("img");

          if (this.linkIdRouteParam && this.linkIdRouteParam !== "0") {
            if (this.isWidgetOrMultipleFamilies()) this.logEvent();

            this.organisationLinkClient
              .getOrganisationLinkLogoByLinkIdAndLogPageLoadEvent(
                Number(this.linkIdRouteParam),
                "",
                0,
                ProductTypeEnum.None,
                "",
                0,
              )
              .then((logoUrl) => {
                if (logoUrl != null && logoUrl.length > 0) {
                  imgs[0].src = this.enterpriseLinkLogo = logoUrl;
                } else {
                  this.enterpriseLinkLogo = imgs[0].src;
                }
              });
          } else {
            this.organisationLinkClient
              .getEnterpriseLinkId(this.organisation.id, LinkTypeEnum.AllLoans)
              .then((linkId) => {
                if (linkId) {
                  this.linkIdRouteParam = linkId.toString();
                  if (this.isWidgetOrMultipleFamilies()) this.logEvent();
                } else {
                  this.noPermissionErrorMsg = "We are unable to compare loans right now.  Please contact your broker.";
                }

                const imgs = document.getElementsByTagName("img");
                this.enterpriseLinkLogo = imgs[0].src;
              });
          }
        } else {
          this.organisationClient.findOrganisationAdminByOrgCode(this.orgCode).then((admin) => {
            this.noPermissionErrorMsg = admin
              ? `We are unable to compare loans right now. Please contact your broker: ${admin.email}.`
              : "We are unable to compare loans right now.  Please contact your broker.";
          });
        }
      });
  }

  isWidgetOrMultipleFamilies() {
    if (
      this.isWidget ||
      (this.productFamilyType &&
        (this.productFamilyType.length > 1 || this.productFamilyType[0] == ProductFamilyEnum.None))
    ) {
      return true;
    }

    return false;
  }
}
